//
// locales/glitch/id.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/id';
import localeData from 'react-intl/locale-data/id.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
